import React from 'react';
import { Drawer, Form, Button, Message, useToaster } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { addServiceLine } from './../../../services/serviceline.service';
import { useTranslation } from 'react-i18next';


interface DrawerViewProps {
  open: boolean;
  onClose: () => void;
}

const DrawerView: React.FC<DrawerViewProps> = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const toaster = useToaster();
  const serviceLines = useSelector(state => state.serviceLine.data);

  const [formValue, setFormValue] = React.useState({
    serviceLine: ''
  });

  React.useEffect(() => {
    if (!open) {
      setFormValue({
        serviceLine: ''
      });
    }
  }, [open]);

  const isDuplicateDepartment = (name: string) => {
    return serviceLines.some(dept => dept.serviceLine.toLowerCase() === name.toLowerCase());
  };
  const { t } = useTranslation();

  const handleSubmit = async () => {
    const trimmedServiceLine = formValue.serviceLine.trim();

    if (!trimmedServiceLine) return;

    if (isDuplicateDepartment(trimmedServiceLine)) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          Team "{trimmedServiceLine}" already exists
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }

    try {
      await dispatch(addServiceLine(formValue));
      toaster.push(
        <Message type="success" duration={3000} showIcon>
          {t('Team successfully created')}
        </Message>,
        { placement: 'topCenter' }
      );
      onClose();
    } catch (error) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          {t('Failed to create team. Please try again.')}
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>{t('Create New Team')}</Drawer.Title>
        <Drawer.Actions>
          <Button
            onClick={handleSubmit}
            appearance="primary"
            disabled={!formValue.serviceLine.trim()}
          >
            {t('Save')}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue}>
          <Form.Group>
            <Form.ControlLabel>{t('Team Name')}</Form.ControlLabel>
            <Form.Control name="serviceLine" placeholder={t("Enter team name")} required />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default DrawerView;
